<app-loading-panel [show]="company == null"></app-loading-panel>

@if (company != null) {
  <section class="pc-settings-page">
    <header class="pc-settings-header">
      <div class="pc-settings-header__copy">
        <h2>Account</h2>
        <p>Manage your company profile, regional settings, and workspace preferences.</p>
      </div>

      <div class="pc-settings-header__actions">
        <app-manage-billing-btn [customerId]="company.paymentProviderCustomerId"></app-manage-billing-btn>
        <button mat-stroked-button [disabled]="!dataUpdated() || saving" (click)="get()">
          <mat-icon>undo</mat-icon>
          Discard
        </button>
        <button mat-raised-button color="primary" [disabled]="!dataUpdated() || saving" (click)="save()">
          @if (saving) {
            <mat-spinner diameter="18" strokeWidth="3"></mat-spinner>
          } @else {
            <mat-icon>save</mat-icon>
          }
          {{ saving ? 'Saving…' : 'Save changes' }}
        </button>
      </div>
    </header>

    <div class="pc-settings-card pc-profile-card">
      <div class="pc-settings-card__heading">
        <div>
          <h3>Company profile</h3>
          <p>This information identifies your workspace throughout PlanaCan.</p>
        </div>
      </div>

      <div class="pc-profile-layout">
        <div class="pc-logo-field">
          <span class="pc-field-label">Company logo</span>
          <div class="pc-logo-wrap">
            <button type="button" class="pc-logo-button" (click)="imageClick()" aria-label="Change company logo">
              <img [src]="companyImageUrl" alt="Company logo">
              <span class="pc-logo-overlay"><mat-icon>photo_camera</mat-icon>Change</span>
            </button>
            @if (customCompanyImage) {
              <button type="button" mat-icon-button class="pc-logo-remove" (click)="minusClick()" aria-label="Remove custom company logo" title="Remove custom logo">
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
          <span class="pc-field-hint">Square images work best.</span>
        </div>

        <div class="pc-profile-fields">
          <mat-form-field appearance="outline">
            <mat-label>Company name</mat-label>
            <input type="text" matInput [(ngModel)]="company.name">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Time zone</mat-label>
            <mat-select [(ngModel)]="company.timezone">
              @for (t of timezones; track t.key) {
                <mat-option [value]="t.key">{{t.display}}</mat-option>
              }
            </mat-select>
            <mat-hint>Used when scheduling tasks, events, and notifications.</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="pc-settings-card pc-preferences-card">
      <div class="pc-settings-card__heading">
        <div>
          <h3>Workspace preferences</h3>
          <p>Choose how supporting information appears for your team.</p>
        </div>
      </div>

      <div class="pc-setting-row">
        <div class="pc-setting-row__icon"><mat-icon>info_outline</mat-icon></div>
        <div class="pc-setting-row__copy">
          <strong>Event tooltips</strong>
          <span>Show helpful event details when users hover over calendar items.</span>
        </div>
        <mat-slide-toggle [(ngModel)]="company.eventsTooltips" aria-label="Enable event tooltips"></mat-slide-toggle>
      </div>
    </div>
  </section>
}
